import React from 'react';
import PropTypes from 'prop-types';

import { Grid } from 'components/Grid';
import { HeadingBoundary } from 'components/Heading';
import { SectionHeader } from 'patterns/SectionHeader';
import { LogoList } from 'patterns/LogoList';
import { cx } from 'utility';
import * as styles from './LogoListBlock.module.scss';

const propTypes = {
    background: PropTypes.bool,
    className: PropTypes.string,
    description: PropTypes.string,
    items: PropTypes.array,
    itemsPerRow: PropTypes.string,
    title: PropTypes.string,
};

const defaultProps = {
    background: false,
    className: '',
    description: '',
    items: [],
    itemsPerRow: 'auto',
    title: '',
};

function getClasses({ className }) {
    const classes = cx(
        className,
        styles['logoListBlock'],
    );

    return classes || undefined;
}

function LogoListBlock({
    background,
    className,
    description,
    items,
    itemsPerRow,
    title,
}) {
    const classes = getClasses({ className });

    return (
        <div className={classes}>
            <HeadingBoundary>
                <Grid background={background} block={true}>
                    {(description || title) && (
                        <SectionHeader
                            description={description}
                            title={title}
                        />
                    )}
                    <LogoList
                        items={items}
                        itemsPerRow={itemsPerRow}
                    />
                </Grid>
            </HeadingBoundary>
        </div>
    );
}

LogoListBlock.propTypes = propTypes;
LogoListBlock.defaultProps = defaultProps;

export { LogoListBlock };
